import { PageHeader } from '@ksyos/design-system';
import { ManagerAuthorization } from '@common/enums/';
import { PageTemplate } from '@frontend/components/templates/PageTemplate';
import { getSelectedLanguage } from '@frontend/translate';
import { assertHasAuthorization } from '@frontend/utils/assertHasAuthorization';
import type { ImportDhdFileProps } from './ImportDhdFile';
import { ImportDhdFile } from './ImportDhdFile';

const importFilesProps: ImportDhdFileProps[] = [
    { header: 'BronSpecialisme.csv', table: 'specialisms', useLanguageOption: true },
    { header: 'BronICD10.csv', table: 'icd10Codes', useImportActionOption: true, useLanguageOption: true },
    { header: 'AfleidingICD10.csv', table: 'icd10DhdConversions' },
    { header: 'AfleidingDBC.csv', table: 'dbcDhdConversions' },
    { header: 'ThesaurusConceptRol.csv', table: 'thesaurusRoles' },
    { header: 'ThesaurusTerm.csv', table: 'thesaurusTerms' },
];

export function ImportDhd() {
    assertHasAuthorization(ManagerAuthorization.importDhd);
    const translate = getSelectedLanguage();

    return (
        <PageTemplate width="medium">
            <PageHeader title={`${translate.imports.dhd} ${translate.imports.import}`} />

            {importFilesProps.map((importFile) => (
                <ImportDhdFile
                    {...importFile}
                    key={importFile.header}
                />
            ))}
        </PageTemplate>
    );
}
